import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { useTranslation } from "react-i18next";
import { useSolutionGroups } from "../../pages/Servicos/ServicesContent";
import { useInView } from "../../util/useInView";
import "./CatalogPreview.css";

// Prévia do catálogo na Home: o mesmo conteúdo do menu "Soluções" do header, condensado em 8 cards (tópico e as
// soluções dele). O botão leva ao catálogo completo (/solucoes, o mapa em círculo).
export default function CatalogPreview() {
  const { t } = useTranslation();
  const groups = useSolutionGroups();
  const [ref, state] = useInView<HTMLUListElement>(0.1);

  return (
    <section className="cz-catalog-preview" aria-labelledby="cz-catalog-preview-title">
      <div className="cz-catalog-preview__inner">
        <div className="cz-catalog-preview__head">
          <div className="cz-catalog-preview__intro">
            <span className="cz-eyebrow">{t("home.catalog_eyebrow", "Catálogo")}</span>
            <h2 className="cz-catalog-preview__title" id="cz-catalog-preview-title">
              {t("home.catalog_title", "Explore nosso catálogo de soluções")}
            </h2>
            <p className="cz-catalog-preview__text">
              {t("home.catalog_text", "Conheça nossas soluções completas para educação, governo e empresas.")}
            </p>
          </div>
          <Link to="/solucoes" className="cz-outline-btn cz-outline-btn--pink cz-catalog-preview__cta">
            {t("home.catalog_cta", "Acessar catálogo completo")}
            <ArrowRight size={16} aria-hidden="true" />
          </Link>
        </div>

        <ul ref={ref} className={`cz-catalog-preview__grid${state}`}>
          {groups.map(({ key, title, icon: Icon, to, items }, i) => (
            <li key={key} className="cz-topic-card" data-reveal style={{ "--i": i } as React.CSSProperties}>
              <div className="cz-topic-card__top">
                <span className="cz-topic-card__icon" aria-hidden="true">
                  <Icon size={22} strokeWidth={1.7} />
                </span>
                <span className="cz-topic-card__count">
                  {t("solutions_catalog.items_count", { count: items.length, defaultValue: "{{count}} soluções" })}
                </span>
              </div>
              <Link to={to} className="cz-topic-card__title">
                {title}
                <ArrowRight size={16} aria-hidden="true" />
              </Link>
              <ul className="cz-topic-card__items">
                {items.map((item) => (
                  <li key={item.key}>
                    <Link to={item.to} className="cz-topic-card__item">
                      {item.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
